import * as requestLeaseContractStatuses from 'constants/enums/requestLeaseContractStatuses'
import type {RequestLeaseContractStatus} from 'constants/enums/requestLeaseContractStatuses'
import * as requestLeaseStatuses from 'constants/enums/requestLeaseStatuses'
import type {RequestLeaseStatus} from 'constants/enums/requestLeaseStatuses'

type RequestLeaseContractGenerationRule = {
  requestLeaseStatus: RequestLeaseStatus
  contractStatus: RequestLeaseContractStatus
  finalFileState: 'any' | 'missing'
}

export const REQUEST_LEASE_CONTRACT_GENERATION_RULES = [
  {
    requestLeaseStatus: requestLeaseStatuses.GENERATION,
    contractStatus: requestLeaseContractStatuses.NEW,
    finalFileState: 'any',
  },
  {
    requestLeaseStatus: requestLeaseStatuses.PROCESSING,
    contractStatus: requestLeaseContractStatuses.NEW,
    finalFileState: 'any',
  },
  {
    requestLeaseStatus: requestLeaseStatuses.PROCESSING,
    contractStatus: requestLeaseContractStatuses.PENDING_SIGNATURE,
    finalFileState: 'missing',
  },
] as const satisfies readonly RequestLeaseContractGenerationRule[]
